import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { loadGA, trackPageView, analyticsEnabled } from "@/lib/analytics";

// GA4 wiring: loads only when enabled + user consented to analytics cookies.
// Reacts to consent changes and tracks SPA route changes as page views.
export default function Analytics() {
  const location = useLocation();

  useEffect(() => {
    if (!analyticsEnabled()) return undefined;
    loadGA();
    const onConsent = () => {
      loadGA();
      trackPageView(window.location.pathname + window.location.search);
    };
    window.addEventListener("oxo:consent-updated", onConsent);
    return () => window.removeEventListener("oxo:consent-updated", onConsent);
  }, []);

  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location.pathname, location.search]);

  return null;
}
